import axiosInstance from '@api/axiosInstance';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useDialog from './useDialog';
import { useSuspenseQuery } from '@tanstack/react-query';
import { settingsQueryOptions } from '@utils/queryOptions';
import useManagePlan from './useManagePlan';

const useApiErrorHandler = () => {
    const { t } = useTranslation();
    const dialog = useDialog();
    const openManagePlan = useManagePlan();

    const { data: settings } = useSuspenseQuery(settingsQueryOptions());

    useEffect(() => {
        dialog.close();
    }, [settings.email_plan]);

    useEffect(() => {
        const resIntreceptor = axiosInstance.interceptors.response.use(
            response => response,
            error => {
                if (error.response?.status === 402) {
                    dialog.open({
                        title: error.response.data.title,
                        message: error.response.data.detail,
                        cancelLabel: t('Not now'),
                        confirmLabel: t('Upgrade Plan'),
                        confirmButtonProps: { variant: 'filled' },
                        onConfirm: openManagePlan,
                    });
                    return Promise.reject(error);
                }
                return Promise.reject(error);
            },
        );

        return () => {
            axiosInstance.interceptors.response.eject(resIntreceptor);
        };
    }, []);
};

export default useApiErrorHandler;
